export const FormControl = {
  baseStyle: {
    marginTop: "5%",
  },
};
